import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "oidc-return-page" }
const _hoisted_2 = { id: "OIDCReturnPage" }
const _hoisted_3 = { class: "diag-header-nav" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "diag-permission-label" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "diag-warning diag-load-error"
}
const _hoisted_10 = { class: "diag-captured" }
const _hoisted_11 = {
  key: 0,
  class: "diag-error"
}
const _hoisted_12 = { class: "diag-table" }
const _hoisted_13 = { class: "diag-error-value" }
const _hoisted_14 = { class: "diag-token-label" }
const _hoisted_15 = { class: "diag-raw" }
const _hoisted_16 = {
  key: 0,
  class: "diag-table"
}
const _hoisted_17 = {
  key: 2,
  class: "diag-note"
}
const _hoisted_18 = { class: "diag-table" }
const _hoisted_19 = { class: "diag-table" }
const _hoisted_20 = { class: "diag-table" }
const _hoisted_21 = { class: "diag-table" }
const _hoisted_22 = { class: "diag-table" }
const _hoisted_23 = { class: "diag-table" }
const _hoisted_24 = { class: "diag-table" }
const _hoisted_25 = { class: "diag-table" }
const _hoisted_26 = { class: "diag-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CwePageHeader = _resolveComponent("CwePageHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CwePageHeader, { authenticationRequired: true }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("a", {
          class: "diag-header-link",
          href: _ctx.signInUrl
        }, "Return to Sign-In", 8, _hoisted_4),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "diag-header-divider" }, "|", -1)),
        _createElementVNode("a", {
          class: "diag-header-link",
          href: _ctx.dashboardUrl
        }, "Complete Login", 8, _hoisted_5)
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "diag-title" }, "SENSITIVE: OIDC Return Diagnostics", -1)),
      _cache[20] || (_cache[20] = _createElementVNode("p", { class: "diag-warning" }, " This report contains raw tokens and personal data. Handle accordingly; do not forward. ", -1)),
      (_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["diag-banner", _ctx.submitSuccess ? 'diag-banner--success' : 'diag-banner--error']),
            role: "alert"
          }, _toDisplayString(_ctx.bannerMessage), 3))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: "diag-permission",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permissionGranted) = $event)),
            disabled: _ctx.submitting || _ctx.submitted
          }, null, 8, _hoisted_7), [
            [_vModelCheckbox, _ctx.permissionGranted]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, " I understand this report contains raw tokens and personal data, and I authorize emailing it to the configured recipients. ", -1))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "diag-submit-btn",
          disabled: !_ctx.permissionGranted || _ctx.submitting || _ctx.submitted
        }, " Email report ", 8, _hoisted_8)
      ], 32),
      (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.loadError), 1))
        : (_ctx.report)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("p", _hoisted_10, "Captured (UTC): " + _toDisplayString(_ctx.report.capturedAtUtc), 1),
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "diag-group" }, "SUMMARY", -1)),
              (_ctx.postError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "diag-section" }, "Identity provider error returned to callback", -1)),
                    _createElementVNode("table", _hoisted_12, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postError.fields, (pair, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'errfield' + i
                          }, [
                            _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.nz(pair.value)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "diag-section" }, "All captured JWT tokens (deduped, signatures neutered)", -1)),
              (_ctx.capturedJwtTokens.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.capturedJwtTokens, (tok, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'tok' + i,
                      class: "diag-token"
                    }, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(tok.label), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.nz(tok.raw)), 1),
                      (tok.claims.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tok.claims, (pair, j) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: 'tokclaim' + i + '_' + j
                                }, [
                                  _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("p", _hoisted_17, "(none)")),
              _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "diag-section" }, "Auth cookie claims", -1)),
              _createElementVNode("table", _hoisted_18, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.responseAuthCookieClaims, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'authclaim' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "diag-group" }, "REQUEST", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "diag-section" }, "Request Headers", -1)),
              _createElementVNode("table", _hoisted_19, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.requestHeaders, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'reqheader' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "diag-section" }, "Request Cookies", -1)),
              _createElementVNode("table", _hoisted_20, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.requestCookies, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'reqcookie' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "diag-section" }, "Request Form Data", -1)),
              _createElementVNode("table", _hoisted_21, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.requestForm, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'reqform' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "diag-group" }, "RESPONSE", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "diag-section" }, "Response Headers", -1)),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.responseHeaders, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'resheader' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "diag-section" }, "Response Cookies", -1)),
              _createElementVNode("table", _hoisted_23, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.responseCookies, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'rescookie' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "diag-section" }, "Response Form Data", -1)),
              _createElementVNode("table", _hoisted_24, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.responseForm, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'resform' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "diag-group" }, "DETAILS", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "diag-section" }, "Verification (re-derived from inputs)", -1)),
              _createElementVNode("table", _hoisted_25, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.verification, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'ver' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "diag-section" }, "B2C token-endpoint response fields (auth-code exchange)", -1)),
              _createElementVNode("table", _hoisted_26, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.tokenEndpointResponse, (pair, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'tep' + i
                    }, [
                      _createElementVNode("th", null, _toDisplayString(pair.key), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.nz(pair.value)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}